export default function StatCard({ icon: Icon, label, value, color, small }) {
  return (
    <div className="bg-neutral-900/50 border border-neutral-800 rounded-xl p-5">
      <div
        className="w-10 h-10 rounded-lg flex items-center justify-center mb-3"
        style={{ background: `${color}15`, color }}
      >
        <Icon className="w-5 h-5" />
      </div>
      <div className={`text-white font-bold ${small ? 'text-lg' : 'text-2xl'}`}>{value}</div>
      <div className="text-neutral-500 text-xs uppercase tracking-wider mt-1">{label}</div>
    </div>
  );
}
